import React, { Component } from "react";
import { connect } from 'react-redux';
import { mapDispatchToProps } from '../../redux/actions';
import "../../css/MultiSelectDropdown.scss";
import { showNeedsRecalcModal } from "./FactoryRequestUtility";

export interface IOption {
  name: string;
  value: string;
}

interface MultiSelectProps {
  options: IOption[];
  onChange?: (id: number, selected: string[]) => void;
  initialSelected: string[];
  modificationId:number;
  className:string;
  includeAll:boolean;
  titleText:string;
  reduxFactoryRequestBadUnits:any;
}

interface MultiSelectState {
  isOpen: boolean;
  selectedValues: string[];
}
class MultiSelectDropdown extends Component<
  MultiSelectProps,
  MultiSelectState
> {
  private multiSelectRef: React.RefObject<HTMLDivElement>;

  constructor(props: MultiSelectProps) {
    super(props);
    
    this.multiSelectRef = React.createRef();

    this.state = {
      isOpen: false,
      selectedValues: []
    };
  }
  componentDidMount(){
    if (this.props.initialSelected?.length > 0){
      this.setState({selectedValues: this.props.initialSelected});
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  handleClickOutside = (event: MouseEvent) => {
    if (
      this.multiSelectRef.current &&
      !this.multiSelectRef.current.contains(event.target as Node)
    ) {
      if (this.state.isOpen) {
        this.setState({ isOpen: false });
      }
    }
  };
  private toggleDropdown = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  private handleCheckboxChange = (value: string) => {
    const badUnits = this.props.reduxFactoryRequestBadUnits;
    if (badUnits.includes(value) && value !== "All") {
      showNeedsRecalcModal([value]);
      return;
    }
    if (badUnits?.length > 0 && value === "All"){
      showNeedsRecalcModal(badUnits);
      return;
    }

    this.setState(
      (prevState) => {
        let selected = [...prevState.selectedValues];

        // Handle "All" option
        if (value === "All") {
          selected = selected.includes("All") ? [] : ["All"];
        } else {
          // Remove "All" if individual selected
          selected = selected.filter((v) => v !== "All");

          if (selected.includes(value)) {
            selected = selected.filter((v) => v !== value);
          } else {
            selected.push(value);
          }
        }

        return { selectedValues: selected };
      },
      () => {
        // Notify parent if callback provided
        this.props.onChange?.(this.props.modificationId, this.state.selectedValues);
      }
    );
  };

  private getDisplayText() {
    const { selectedValues } = this.state;
    const { options } = this.props;
    
    if (selectedValues.length === 0) {
      return this.props.titleText;
    }
    if (selectedValues.includes("All")) {
      return "All"; // "All" name shown when selected
    }
    const selectedNames = selectedValues
      .map((val) => options.find((opt) => opt.value === val)?.name)
      .filter((name): name is string => !!name);
  
    return selectedNames.join(", ");
  }

  render() {
    const options: IOption[] = [
      ...(this.props.includeAll ? [{ name: "All", value: "All" }] : []),
      ...this.props.options
    ];

    return (
      <div className="ms-container" ref={this.multiSelectRef}>
        <div className={"ms-header " + this.props.className} onClick={this.toggleDropdown}>
          {this.getDisplayText()}
        </div>

        {this.state.isOpen && (
          <div className="ms-dropdown">
            {options.map((opt) => (
              <label key={opt.value} className="ms-option">
                <input
                  type="checkbox"
                  className="ms-checkbox"
                  checked={this.state.selectedValues.includes(opt.value)}
                  onChange={() => this.handleCheckboxChange(opt.value)}
                />
                {opt.name}
              </label>
            ))}
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    reduxFactoryRequestBadUnits: state.reduxFactoryRequestBadUnits
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(MultiSelectDropdown);
